import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions } from "../../../../Custom/Custom";
import { useNavigate } from "react-router-dom";
import { generateExcelASITable7 } from "../../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel";
import messages from '../../../../assets/Messages.json';
import asiTitle from '../../../../asi.json';

/** null / NULL / empty / whitespace → 0 for Excel cells */
const table7CellValue = (value) => {
  if (value == null || value === undefined) return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  const str = String(value).trim();
  if (str === '') return 0;
  const lower = str.toLowerCase();
  if (lower === 'null' || lower === 'undefined' || lower === 'nil') return 0;
  return value;
};

const table7Field = (item, ...keys) => {
  for (const key of keys) {
    if (item && Object.prototype.hasOwnProperty.call(item, key)) {
      return table7CellValue(item[key]);
    }
  }
  return 0;
};

const Table7Report = () => {
  const [years, setYears] = useState([]);
  const [yearName, setYearName] = useState("");
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });

  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const navigate = useNavigate();
  const config = getAuthHeaders();


  const storedLanguage = localStorage.getItem('language');

  //get next Years 
  const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
    const nextYearShort = nextYear.toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  //get Years 
  const getAllYears = () => {
    // const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = new Date().getFullYear() - 2; year >= 2013; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    setYears(getAllYears());
  }, []);



  const handleDropdownChange = (e) => {
    setYearName(e.target.value);
  };

  const downloadStaticTable7Xlsx = async () => {
    const fileUrl = `pdf/ASI_Table7.xlsx`;
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error("File not found");
      }
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = "ASI_Table7.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error(error);
      toast.error("File not found", messages.COLOR_RED);
    } finally {
      showLoading(false);
    }
  };


  const handleGenerateExcel = () => {
    if (!yearName) {
      toast.error("Please select a Survey Year", messages.COLOR_RED);
      return;
    }

    showLoading(true);
    // Prepare payload
    const payload = {
      survey_year: yearName,
    };
  if (String(yearName) === "2023") {
      downloadStaticTable7Xlsx();
      return false;
    }
    // POST request to API
    axios
      .post(`${API_URL}api/asi/reports/HQReports/asigetTable7Report`, payload, config)
      .then((response) => {
        // Handle success and generate the Excel file directly
        const table7Report = response.data.data.asiTable7Report;


        if (!table7Report || table7Report.length === 0) {
          toast.info("Data not found");
          showLoading(false);
          return;
        }

        let excelFileName = 'ASI_Table7';
        const excelObjectData = {
          fileName: excelFileName,
          reportType: excelFileName,
          fileType: 'xlsx',
          sheetName: "ASI_Table7",
          firstRowMergeCells: "A1:T1",
          firstRowExportData: 'सारिणी -७',
          firstRowCellNumber: 11,
          secondRowMergeCells: "A2:T2",
          secondRowText: `वार्षिक उद्योग सर्वेक्षण ${yearName}-${parseInt(yearName) + 1}`,
          headerEnglishColumns: [
            'DSL No', 'उद्योग संकेत\n(4 अंकीय )\n(एन.आई.सी. 2008 )', 'पंजीकृत', 'Sector\nCODE', 'Type of organization', 'Type of ownership', 'unit has ISO Certification',
            ' Year of Initial Production', 'No. of month of Operation', 'Enterprise using computer', 'Enterprise\nuse\nInternet', 'Enterprise have own Website',
            'Enterprise receive through', 'Enterprise use Internet for business', 'Enterprise access the  Internet', 'Enterprise have a local area', 'Electrical Saving',
            'Coal\nSaving', 'Oil\nSaving', 'Gas\nSaving'
          ],
        };

        const transformedData = table7Report.map((item) => [
          table7Field(item, 'dslNo', 'DSL_NO'),
          table7Field(item, 'NicCodePerframe', 'NIC_CODE_PERFRAME'),
          table7Field(item, 'status', 'STATUS'),
          table7Field(item, 'SectorCODE', 'SECTOR', 'SectorCODE'),
          table7Field(item, 'TypeOfOrganization', 'TYPE_ORGANIZATION_CODE'),
          table7Field(item, 'TypeOfOwnership', 'TYPE_OWNERSHIP_CODE'),
          table7Field(item, 'UnithasISOCertificatio', 'ISO_CERTIFICATION_14000'),
          table7Field(item, 'YearOfInitialProduction', 'YEAR_INITIAL_PRODUCTION'),
          table7Field(item, 'NoOfmonthOfOperation', 'NUMBER_MONTHSOF_OPERATION'),
          table7Field(item, 'EnterpriseUsingComputer', 'K1'),
          table7Field(item, 'EnterpriseUseInternet', 'K2'),
          table7Field(item, 'EnterprisehaveOwnWebsite', 'K3'),
          table7Field(item, 'EnterpriseReceiveThrough', 'K4'),
          table7Field(item, 'EnterpriseuseInternetforBusiness', 'K5'),
          table7Field(item, 'EnterpriseAccesstheInternet', 'K6'),
          table7Field(item, 'EnterprisehaveaLocalArea', 'K7'),
          table7Field(item, 'ElectricalSaving', 'L8'),
          table7Field(item, 'CoalSaving', 'L9'),
          table7Field(item, 'OilSaving', 'L10'),
          table7Field(item, 'GasSaving', 'L11'),
        ]);

        excelObjectData.excelRowData = transformedData;

        generateExcelASITable7(excelObjectData);

        showLoading(false);
      })
      .catch((error) => {
        console.error('API Error:', error);
        showLoading(false);
      });
  };


  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.TABLE_SEVEN_REPORT : asiTitle.en.TABLE_SEVEN_REPORT }} />
              </h4>
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">
                    {storedLanguage === 'hi' ? asiTitle.hi.SURVEY_YAER : asiTitle.en.SURVEY_YAER}
                  </label>
                  <select
                    name="year_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearName}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                    {years
                      .sort((a, b) => b - a) 
                      .map((yearName, index) => (
                        <option key={index} value={yearName}>
                          {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-2 col-lg-12 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default Table7Report